// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_BuscaReciboResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos/buscaRecibo/{compromisso_id}
 *
 * Returns an array of receipt PDF documents for a compromisso.
 * If no receipt exists, returns an empty array.
 *
 * The documentos_model->buscaDocumento() proxies the request to the
 * html2pdf-service Go microservice at /busca/{tipo}/{owner}/{owner_id}.
 * Each document mirrors html2pdf-service's `document.Document` GORM model —
 * see Compromissos_BuscaReciboRow for the field docs and source pointers.
 *
 * @see Compromissos_BuscaReciboRow
 * @see Documentos_model::buscaDocumento()
 * @see Compromissos::buscaRecibo()
 */
import type { Compromissos_BuscaReciboRow } from './Compromissos_BuscaReciboRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Compromissos_BuscaReciboResponseDados = Compromissos_BuscaReciboRow[];

export type Compromissos_BuscaReciboResponse = ApiResponse<Compromissos_BuscaReciboResponseDados>;

registerResponseContract('Compromissos_BuscaReciboResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'number',  required: false },
      CreatedAt: { type: 'string',  required: false },
      UpdatedAt: { type: 'string',  required: false },
      DeletedAt: { type: 'string',  required: false },
      Type:      { type: 'string',  required: false },
      Owner:     { type: 'string',  required: false },
      OwnerID:   { type: 'number',  required: false },
      Src:       { type: 'string',  required: false },
    },
  },
})
